/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as UnauthorisedRouteImport } from './routes/unauthorised'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SelectContextRouteImport } from './routes/select-context'
import { Route as RequestPasswordResetRouteImport } from './routes/request-password-reset'
import { Route as PasswordLinkSentRouteImport } from './routes/password-link-sent'
import { Route as FacilityRouteRouteImport } from './routes/facility/route'
import { Route as CouncilRouteRouteImport } from './routes/council/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as CouncilIndexRouteImport } from './routes/council/index'
import { Route as FacilitySettingsRouteImport } from './routes/facility/settings'
import { Route as FacilityHomeRouteImport } from './routes/facility/home'
import { Route as FacilityHistoryBagRouteImport } from './routes/facility/history-bag'
import { Route as FacilityHistoryAuditRouteImport } from './routes/facility/history-audit'
import { Route as FacilityHistoryRouteImport } from './routes/facility/history'
import { Route as FacilityDeleteAccountRouteImport } from './routes/facility/delete-account'
import { Route as FacilityChangePasswordRouteImport } from './routes/facility/change-password'
import { Route as FacilityBaleProcessedRouteImport } from './routes/facility/bale-processed'
import { Route as FacilityBaleOutboundRouteImport } from './routes/facility/bale-outbound'
import { Route as FacilityBaleInboundRouteImport } from './routes/facility/bale-inbound'
import { Route as FacilityBaleCreateRouteImport } from './routes/facility/bale-create'
import { Route as FacilityBagScanRouteImport } from './routes/facility/bag-scan'
import { Route as FacilityBagAuditRouteImport } from './routes/facility/bag-audit'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AppTermsRouteImport } from './routes/_app/terms'
import { Route as AppSubscriptionRouteImport } from './routes/_app/subscription'
import { Route as AppSignupDetailsRouteImport } from './routes/_app/signup-details'
import { Route as AppShopRouteImport } from './routes/_app/shop'
import { Route as AppScanHistoryRouteImport } from './routes/_app/scan-history'
import { Route as AppScanRouteImport } from './routes/_app/scan'
import { Route as AppRewardsRouteImport } from './routes/_app/rewards'
import { Route as AppReportIssueRouteImport } from './routes/_app/report-issue'
import { Route as AppPrivacyRouteImport } from './routes/_app/privacy'
import { Route as AppPastWinnersRouteImport } from './routes/_app/past-winners'
import { Route as AppInformExistingRouteImport } from './routes/_app/inform-existing'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppEnterCodeRouteImport } from './routes/_app/enter-code'
import { Route as AppDeleteAccountRouteImport } from './routes/_app/delete-account'
import { Route as AppChooseSubscriptionRouteImport } from './routes/_app/choose-subscription'
import { Route as AppCheckoutProductRouteImport } from './routes/_app/checkout-product'
import { Route as AppChangePasswordRouteImport } from './routes/_app/change-password'
import { Route as AppCancelAutoRenewRouteImport } from './routes/_app/cancel-auto-renew'
import { Route as AppBillingRouteImport } from './routes/_app/billing'
import { Route as AppBagScannedRouteImport } from './routes/_app/bag-scanned'
import { Route as AppAppUpdatesRouteImport } from './routes/_app/app-updates'
import { Route as AppAlertsRouteImport } from './routes/_app/alerts'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAboutSubscriptionsRouteImport } from './routes/_app/about-subscriptions'
import { Route as CouncilCouncilIdRouteRouteImport } from './routes/council/$councilId/route'
import { Route as CouncilCouncilIdIndexRouteImport } from './routes/council/$councilId/index'
import { Route as FacilityEditScanScanIdRouteImport } from './routes/facility/edit-scan.$scanId'
import { Route as CouncilCouncilIdDashboardRouteImport } from './routes/council/$councilId/dashboard'
import { Route as AppSubscriptionDetailProductIdRouteImport } from './routes/_app/subscription-detail.$productId'
import { Route as AppCheckoutSubscriptionProductPriceIdRouteImport } from './routes/_app/checkout-subscription.$productPriceId'
import { Route as AppCheckoutSubscriptionResultSessionIdRouteImport } from './routes/_app/checkout-subscription-result.$sessionId'
import { Route as AppCheckoutProductResultSessionIdRouteImport } from './routes/_app/checkout-product-result.$sessionId'

const AppIndexLazyRouteImport = createFileRoute('/_app/')()
const AppAboutLazyRouteImport = createFileRoute('/_app/about')()

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorisedRoute = UnauthorisedRouteImport.update({
  id: '/unauthorised',
  path: '/unauthorised',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectContextRoute = SelectContextRouteImport.update({
  id: '/select-context',
  path: '/select-context',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestPasswordResetRoute = RequestPasswordResetRouteImport.update({
  id: '/request-password-reset',
  path: '/request-password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordLinkSentRoute = PasswordLinkSentRouteImport.update({
  id: '/password-link-sent',
  path: '/password-link-sent',
  getParentRoute: () => rootRouteImport,
} as any)
const FacilityRouteRoute = FacilityRouteRouteImport.update({
  id: '/facility',
  path: '/facility',
  getParentRoute: () => rootRouteImport,
} as any)
const CouncilRouteRoute = CouncilRouteRouteImport.update({
  id: '/council',
  path: '/council',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexLazyRoute = AppIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any).lazy(() => import('./routes/_app/index.lazy').then((d) => d.Route))
const CouncilIndexRoute = CouncilIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CouncilRouteRoute,
} as any)
const AppAboutLazyRoute = AppAboutLazyRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AppRouteRoute,
} as any).lazy(() => import('./routes/_app/about.lazy').then((d) => d.Route))
const FacilitySettingsRoute = FacilitySettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityHomeRoute = FacilityHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityHistoryBagRoute = FacilityHistoryBagRouteImport.update({
  id: '/history-bag',
  path: '/history-bag',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityHistoryAuditRoute = FacilityHistoryAuditRouteImport.update({
  id: '/history-audit',
  path: '/history-audit',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityHistoryRoute = FacilityHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityDeleteAccountRoute = FacilityDeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityChangePasswordRoute = FacilityChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityBaleProcessedRoute = FacilityBaleProcessedRouteImport.update({
  id: '/bale-processed',
  path: '/bale-processed',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityBaleOutboundRoute = FacilityBaleOutboundRouteImport.update({
  id: '/bale-outbound',
  path: '/bale-outbound',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityBaleInboundRoute = FacilityBaleInboundRouteImport.update({
  id: '/bale-inbound',
  path: '/bale-inbound',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityBaleCreateRoute = FacilityBaleCreateRouteImport.update({
  id: '/bale-create',
  path: '/bale-create',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityBagScanRoute = FacilityBagScanRouteImport.update({
  id: '/bag-scan',
  path: '/bag-scan',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const FacilityBagAuditRoute = FacilityBagAuditRouteImport.update({
  id: '/bag-audit',
  path: '/bag-audit',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTermsRoute = AppTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSubscriptionRoute = AppSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSignupDetailsRoute = AppSignupDetailsRouteImport.update({
  id: '/signup-details',
  path: '/signup-details',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppShopRoute = AppShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScanHistoryRoute = AppScanHistoryRouteImport.update({
  id: '/scan-history',
  path: '/scan-history',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScanRoute = AppScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRewardsRoute = AppRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReportIssueRoute = AppReportIssueRouteImport.update({
  id: '/report-issue',
  path: '/report-issue',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPrivacyRoute = AppPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPastWinnersRoute = AppPastWinnersRouteImport.update({
  id: '/past-winners',
  path: '/past-winners',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInformExistingRoute = AppInformExistingRouteImport.update({
  id: '/inform-existing',
  path: '/inform-existing',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEnterCodeRoute = AppEnterCodeRouteImport.update({
  id: '/enter-code',
  path: '/enter-code',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDeleteAccountRoute = AppDeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppChooseSubscriptionRoute = AppChooseSubscriptionRouteImport.update({
  id: '/choose-subscription',
  path: '/choose-subscription',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCheckoutProductRoute = AppCheckoutProductRouteImport.update({
  id: '/checkout-product',
  path: '/checkout-product',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppChangePasswordRoute = AppChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCancelAutoRenewRoute = AppCancelAutoRenewRouteImport.update({
  id: '/cancel-auto-renew',
  path: '/cancel-auto-renew',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBagScannedRoute = AppBagScannedRouteImport.update({
  id: '/bag-scanned',
  path: '/bag-scanned',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAppUpdatesRoute = AppAppUpdatesRouteImport.update({
  id: '/app-updates',
  path: '/app-updates',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAboutSubscriptionsRoute = AppAboutSubscriptionsRouteImport.update({
  id: '/about-subscriptions',
  path: '/about-subscriptions',
  getParentRoute: () => AppRouteRoute,
} as any)
const CouncilCouncilIdRouteRoute = CouncilCouncilIdRouteRouteImport.update({
  id: '/$councilId',
  path: '/$councilId',
  getParentRoute: () => CouncilRouteRoute,
} as any)
const CouncilCouncilIdIndexRoute = CouncilCouncilIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CouncilCouncilIdRouteRoute,
} as any)
const FacilityEditScanScanIdRoute = FacilityEditScanScanIdRouteImport.update({
  id: '/edit-scan/$scanId',
  path: '/edit-scan/$scanId',
  getParentRoute: () => FacilityRouteRoute,
} as any)
const CouncilCouncilIdDashboardRoute =
  CouncilCouncilIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => CouncilCouncilIdRouteRoute,
  } as any)
const AppSubscriptionDetailProductIdRoute =
  AppSubscriptionDetailProductIdRouteImport.update({
    id: '/subscription-detail/$productId',
    path: '/subscription-detail/$productId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCheckoutSubscriptionProductPriceIdRoute =
  AppCheckoutSubscriptionProductPriceIdRouteImport.update({
    id: '/checkout-subscription/$productPriceId',
    path: '/checkout-subscription/$productPriceId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCheckoutSubscriptionResultSessionIdRoute =
  AppCheckoutSubscriptionResultSessionIdRouteImport.update({
    id: '/checkout-subscription-result/$sessionId',
    path: '/checkout-subscription-result/$sessionId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCheckoutProductResultSessionIdRoute =
  AppCheckoutProductResultSessionIdRouteImport.update({
    id: '/checkout-product-result/$sessionId',
    path: '/checkout-product-result/$sessionId',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/council': typeof CouncilRouteRouteWithChildren
  '/facility': typeof FacilityRouteRouteWithChildren
  '/password-link-sent': typeof PasswordLinkSentRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/select-context': typeof SelectContextRoute
  '/signup': typeof SignupRoute
  '/unauthorised': typeof UnauthorisedRoute
  '/welcome': typeof WelcomeRoute
  '/council/$councilId': typeof CouncilCouncilIdRouteRouteWithChildren
  '/about-subscriptions': typeof AppAboutSubscriptionsRoute
  '/account': typeof AppAccountRoute
  '/alerts': typeof AppAlertsRoute
  '/app-updates': typeof AppAppUpdatesRoute
  '/bag-scanned': typeof AppBagScannedRoute
  '/billing': typeof AppBillingRoute
  '/cancel-auto-renew': typeof AppCancelAutoRenewRoute
  '/change-password': typeof AppChangePasswordRoute
  '/checkout-product': typeof AppCheckoutProductRoute
  '/choose-subscription': typeof AppChooseSubscriptionRoute
  '/delete-account': typeof AppDeleteAccountRoute
  '/enter-code': typeof AppEnterCodeRoute
  '/help': typeof AppHelpRoute
  '/home': typeof AppHomeRoute
  '/inform-existing': typeof AppInformExistingRoute
  '/past-winners': typeof AppPastWinnersRoute
  '/privacy': typeof AppPrivacyRoute
  '/report-issue': typeof AppReportIssueRoute
  '/rewards': typeof AppRewardsRoute
  '/scan': typeof AppScanRoute
  '/scan-history': typeof AppScanHistoryRoute
  '/shop': typeof AppShopRoute
  '/signup-details': typeof AppSignupDetailsRoute
  '/subscription': typeof AppSubscriptionRoute
  '/terms': typeof AppTermsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/facility/bag-audit': typeof FacilityBagAuditRoute
  '/facility/bag-scan': typeof FacilityBagScanRoute
  '/facility/bale-create': typeof FacilityBaleCreateRoute
  '/facility/bale-inbound': typeof FacilityBaleInboundRoute
  '/facility/bale-outbound': typeof FacilityBaleOutboundRoute
  '/facility/bale-processed': typeof FacilityBaleProcessedRoute
  '/facility/change-password': typeof FacilityChangePasswordRoute
  '/facility/delete-account': typeof FacilityDeleteAccountRoute
  '/facility/history': typeof FacilityHistoryRoute
  '/facility/history-audit': typeof FacilityHistoryAuditRoute
  '/facility/history-bag': typeof FacilityHistoryBagRoute
  '/facility/home': typeof FacilityHomeRoute
  '/facility/settings': typeof FacilitySettingsRoute
  '/about': typeof AppAboutLazyRoute
  '/council/': typeof CouncilIndexRoute
  '/': typeof AppIndexLazyRoute
  '/checkout-product-result/$sessionId': typeof AppCheckoutProductResultSessionIdRoute
  '/checkout-subscription-result/$sessionId': typeof AppCheckoutSubscriptionResultSessionIdRoute
  '/checkout-subscription/$productPriceId': typeof AppCheckoutSubscriptionProductPriceIdRoute
  '/subscription-detail/$productId': typeof AppSubscriptionDetailProductIdRoute
  '/council/$councilId/dashboard': typeof CouncilCouncilIdDashboardRoute
  '/facility/edit-scan/$scanId': typeof FacilityEditScanScanIdRoute
  '/council/$councilId/': typeof CouncilCouncilIdIndexRoute
}
export interface FileRoutesByTo {
  '/facility': typeof FacilityRouteRouteWithChildren
  '/password-link-sent': typeof PasswordLinkSentRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/select-context': typeof SelectContextRoute
  '/signup': typeof SignupRoute
  '/unauthorised': typeof UnauthorisedRoute
  '/welcome': typeof WelcomeRoute
  '/about-subscriptions': typeof AppAboutSubscriptionsRoute
  '/account': typeof AppAccountRoute
  '/alerts': typeof AppAlertsRoute
  '/app-updates': typeof AppAppUpdatesRoute
  '/bag-scanned': typeof AppBagScannedRoute
  '/billing': typeof AppBillingRoute
  '/cancel-auto-renew': typeof AppCancelAutoRenewRoute
  '/change-password': typeof AppChangePasswordRoute
  '/checkout-product': typeof AppCheckoutProductRoute
  '/choose-subscription': typeof AppChooseSubscriptionRoute
  '/delete-account': typeof AppDeleteAccountRoute
  '/enter-code': typeof AppEnterCodeRoute
  '/help': typeof AppHelpRoute
  '/home': typeof AppHomeRoute
  '/inform-existing': typeof AppInformExistingRoute
  '/past-winners': typeof AppPastWinnersRoute
  '/privacy': typeof AppPrivacyRoute
  '/report-issue': typeof AppReportIssueRoute
  '/rewards': typeof AppRewardsRoute
  '/scan': typeof AppScanRoute
  '/scan-history': typeof AppScanHistoryRoute
  '/shop': typeof AppShopRoute
  '/signup-details': typeof AppSignupDetailsRoute
  '/subscription': typeof AppSubscriptionRoute
  '/terms': typeof AppTermsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/facility/bag-audit': typeof FacilityBagAuditRoute
  '/facility/bag-scan': typeof FacilityBagScanRoute
  '/facility/bale-create': typeof FacilityBaleCreateRoute
  '/facility/bale-inbound': typeof FacilityBaleInboundRoute
  '/facility/bale-outbound': typeof FacilityBaleOutboundRoute
  '/facility/bale-processed': typeof FacilityBaleProcessedRoute
  '/facility/change-password': typeof FacilityChangePasswordRoute
  '/facility/delete-account': typeof FacilityDeleteAccountRoute
  '/facility/history': typeof FacilityHistoryRoute
  '/facility/history-audit': typeof FacilityHistoryAuditRoute
  '/facility/history-bag': typeof FacilityHistoryBagRoute
  '/facility/home': typeof FacilityHomeRoute
  '/facility/settings': typeof FacilitySettingsRoute
  '/about': typeof AppAboutLazyRoute
  '/council': typeof CouncilIndexRoute
  '/': typeof AppIndexLazyRoute
  '/checkout-product-result/$sessionId': typeof AppCheckoutProductResultSessionIdRoute
  '/checkout-subscription-result/$sessionId': typeof AppCheckoutSubscriptionResultSessionIdRoute
  '/checkout-subscription/$productPriceId': typeof AppCheckoutSubscriptionProductPriceIdRoute
  '/subscription-detail/$productId': typeof AppSubscriptionDetailProductIdRoute
  '/council/$councilId/dashboard': typeof CouncilCouncilIdDashboardRoute
  '/facility/edit-scan/$scanId': typeof FacilityEditScanScanIdRoute
  '/council/$councilId': typeof CouncilCouncilIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/council': typeof CouncilRouteRouteWithChildren
  '/facility': typeof FacilityRouteRouteWithChildren
  '/password-link-sent': typeof PasswordLinkSentRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/select-context': typeof SelectContextRoute
  '/signup': typeof SignupRoute
  '/unauthorised': typeof UnauthorisedRoute
  '/welcome': typeof WelcomeRoute
  '/council/$councilId': typeof CouncilCouncilIdRouteRouteWithChildren
  '/_app/about-subscriptions': typeof AppAboutSubscriptionsRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/app-updates': typeof AppAppUpdatesRoute
  '/_app/bag-scanned': typeof AppBagScannedRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/cancel-auto-renew': typeof AppCancelAutoRenewRoute
  '/_app/change-password': typeof AppChangePasswordRoute
  '/_app/checkout-product': typeof AppCheckoutProductRoute
  '/_app/choose-subscription': typeof AppChooseSubscriptionRoute
  '/_app/delete-account': typeof AppDeleteAccountRoute
  '/_app/enter-code': typeof AppEnterCodeRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/inform-existing': typeof AppInformExistingRoute
  '/_app/past-winners': typeof AppPastWinnersRoute
  '/_app/privacy': typeof AppPrivacyRoute
  '/_app/report-issue': typeof AppReportIssueRoute
  '/_app/rewards': typeof AppRewardsRoute
  '/_app/scan': typeof AppScanRoute
  '/_app/scan-history': typeof AppScanHistoryRoute
  '/_app/shop': typeof AppShopRoute
  '/_app/signup-details': typeof AppSignupDetailsRoute
  '/_app/subscription': typeof AppSubscriptionRoute
  '/_app/terms': typeof AppTermsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/facility/bag-audit': typeof FacilityBagAuditRoute
  '/facility/bag-scan': typeof FacilityBagScanRoute
  '/facility/bale-create': typeof FacilityBaleCreateRoute
  '/facility/bale-inbound': typeof FacilityBaleInboundRoute
  '/facility/bale-outbound': typeof FacilityBaleOutboundRoute
  '/facility/bale-processed': typeof FacilityBaleProcessedRoute
  '/facility/change-password': typeof FacilityChangePasswordRoute
  '/facility/delete-account': typeof FacilityDeleteAccountRoute
  '/facility/history': typeof FacilityHistoryRoute
  '/facility/history-audit': typeof FacilityHistoryAuditRoute
  '/facility/history-bag': typeof FacilityHistoryBagRoute
  '/facility/home': typeof FacilityHomeRoute
  '/facility/settings': typeof FacilitySettingsRoute
  '/_app/about': typeof AppAboutLazyRoute
  '/council/': typeof CouncilIndexRoute
  '/_app/': typeof AppIndexLazyRoute
  '/_app/checkout-product-result/$sessionId': typeof AppCheckoutProductResultSessionIdRoute
  '/_app/checkout-subscription-result/$sessionId': typeof AppCheckoutSubscriptionResultSessionIdRoute
  '/_app/checkout-subscription/$productPriceId': typeof AppCheckoutSubscriptionProductPriceIdRoute
  '/_app/subscription-detail/$productId': typeof AppSubscriptionDetailProductIdRoute
  '/council/$councilId/dashboard': typeof CouncilCouncilIdDashboardRoute
  '/facility/edit-scan/$scanId': typeof FacilityEditScanScanIdRoute
  '/council/$councilId/': typeof CouncilCouncilIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/council'
    | '/facility'
    | '/password-link-sent'
    | '/request-password-reset'
    | '/select-context'
    | '/signup'
    | '/unauthorised'
    | '/welcome'
    | '/council/$councilId'
    | '/about-subscriptions'
    | '/account'
    | '/alerts'
    | '/app-updates'
    | '/bag-scanned'
    | '/billing'
    | '/cancel-auto-renew'
    | '/change-password'
    | '/checkout-product'
    | '/choose-subscription'
    | '/delete-account'
    | '/enter-code'
    | '/help'
    | '/home'
    | '/inform-existing'
    | '/past-winners'
    | '/privacy'
    | '/report-issue'
    | '/rewards'
    | '/scan'
    | '/scan-history'
    | '/shop'
    | '/signup-details'
    | '/subscription'
    | '/terms'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/reset-password'
    | '/facility/bag-audit'
    | '/facility/bag-scan'
    | '/facility/bale-create'
    | '/facility/bale-inbound'
    | '/facility/bale-outbound'
    | '/facility/bale-processed'
    | '/facility/change-password'
    | '/facility/delete-account'
    | '/facility/history'
    | '/facility/history-audit'
    | '/facility/history-bag'
    | '/facility/home'
    | '/facility/settings'
    | '/about'
    | '/council/'
    | '/'
    | '/checkout-product-result/$sessionId'
    | '/checkout-subscription-result/$sessionId'
    | '/checkout-subscription/$productPriceId'
    | '/subscription-detail/$productId'
    | '/council/$councilId/dashboard'
    | '/facility/edit-scan/$scanId'
    | '/council/$councilId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/facility'
    | '/password-link-sent'
    | '/request-password-reset'
    | '/select-context'
    | '/signup'
    | '/unauthorised'
    | '/welcome'
    | '/about-subscriptions'
    | '/account'
    | '/alerts'
    | '/app-updates'
    | '/bag-scanned'
    | '/billing'
    | '/cancel-auto-renew'
    | '/change-password'
    | '/checkout-product'
    | '/choose-subscription'
    | '/delete-account'
    | '/enter-code'
    | '/help'
    | '/home'
    | '/inform-existing'
    | '/past-winners'
    | '/privacy'
    | '/report-issue'
    | '/rewards'
    | '/scan'
    | '/scan-history'
    | '/shop'
    | '/signup-details'
    | '/subscription'
    | '/terms'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/reset-password'
    | '/facility/bag-audit'
    | '/facility/bag-scan'
    | '/facility/bale-create'
    | '/facility/bale-inbound'
    | '/facility/bale-outbound'
    | '/facility/bale-processed'
    | '/facility/change-password'
    | '/facility/delete-account'
    | '/facility/history'
    | '/facility/history-audit'
    | '/facility/history-bag'
    | '/facility/home'
    | '/facility/settings'
    | '/about'
    | '/council'
    | '/'
    | '/checkout-product-result/$sessionId'
    | '/checkout-subscription-result/$sessionId'
    | '/checkout-subscription/$productPriceId'
    | '/subscription-detail/$productId'
    | '/council/$councilId/dashboard'
    | '/facility/edit-scan/$scanId'
    | '/council/$councilId'
  id:
    | '__root__'
    | '/_app'
    | '/council'
    | '/facility'
    | '/password-link-sent'
    | '/request-password-reset'
    | '/select-context'
    | '/signup'
    | '/unauthorised'
    | '/welcome'
    | '/council/$councilId'
    | '/_app/about-subscriptions'
    | '/_app/account'
    | '/_app/alerts'
    | '/_app/app-updates'
    | '/_app/bag-scanned'
    | '/_app/billing'
    | '/_app/cancel-auto-renew'
    | '/_app/change-password'
    | '/_app/checkout-product'
    | '/_app/choose-subscription'
    | '/_app/delete-account'
    | '/_app/enter-code'
    | '/_app/help'
    | '/_app/home'
    | '/_app/inform-existing'
    | '/_app/past-winners'
    | '/_app/privacy'
    | '/_app/report-issue'
    | '/_app/rewards'
    | '/_app/scan'
    | '/_app/scan-history'
    | '/_app/shop'
    | '/_app/signup-details'
    | '/_app/subscription'
    | '/_app/terms'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/reset-password'
    | '/facility/bag-audit'
    | '/facility/bag-scan'
    | '/facility/bale-create'
    | '/facility/bale-inbound'
    | '/facility/bale-outbound'
    | '/facility/bale-processed'
    | '/facility/change-password'
    | '/facility/delete-account'
    | '/facility/history'
    | '/facility/history-audit'
    | '/facility/history-bag'
    | '/facility/home'
    | '/facility/settings'
    | '/_app/about'
    | '/council/'
    | '/_app/'
    | '/_app/checkout-product-result/$sessionId'
    | '/_app/checkout-subscription-result/$sessionId'
    | '/_app/checkout-subscription/$productPriceId'
    | '/_app/subscription-detail/$productId'
    | '/council/$councilId/dashboard'
    | '/facility/edit-scan/$scanId'
    | '/council/$councilId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  CouncilRouteRoute: typeof CouncilRouteRouteWithChildren
  FacilityRouteRoute: typeof FacilityRouteRouteWithChildren
  PasswordLinkSentRoute: typeof PasswordLinkSentRoute
  RequestPasswordResetRoute: typeof RequestPasswordResetRoute
  SelectContextRoute: typeof SelectContextRoute
  SignupRoute: typeof SignupRoute
  UnauthorisedRoute: typeof UnauthorisedRoute
  WelcomeRoute: typeof WelcomeRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorised': {
      id: '/unauthorised'
      path: '/unauthorised'
      fullPath: '/unauthorised'
      preLoaderRoute: typeof UnauthorisedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-context': {
      id: '/select-context'
      path: '/select-context'
      fullPath: '/select-context'
      preLoaderRoute: typeof SelectContextRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-password-reset': {
      id: '/request-password-reset'
      path: '/request-password-reset'
      fullPath: '/request-password-reset'
      preLoaderRoute: typeof RequestPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-link-sent': {
      id: '/password-link-sent'
      path: '/password-link-sent'
      fullPath: '/password-link-sent'
      preLoaderRoute: typeof PasswordLinkSentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facility': {
      id: '/facility'
      path: '/facility'
      fullPath: '/facility'
      preLoaderRoute: typeof FacilityRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/council': {
      id: '/council'
      path: '/council'
      fullPath: '/council'
      preLoaderRoute: typeof CouncilRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexLazyRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/council/': {
      id: '/council/'
      path: '/'
      fullPath: '/council/'
      preLoaderRoute: typeof CouncilIndexRouteImport
      parentRoute: typeof CouncilRouteRoute
    }
    '/_app/about': {
      id: '/_app/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AppAboutLazyRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/facility/settings': {
      id: '/facility/settings'
      path: '/settings'
      fullPath: '/facility/settings'
      preLoaderRoute: typeof FacilitySettingsRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/home': {
      id: '/facility/home'
      path: '/home'
      fullPath: '/facility/home'
      preLoaderRoute: typeof FacilityHomeRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/history-bag': {
      id: '/facility/history-bag'
      path: '/history-bag'
      fullPath: '/facility/history-bag'
      preLoaderRoute: typeof FacilityHistoryBagRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/history-audit': {
      id: '/facility/history-audit'
      path: '/history-audit'
      fullPath: '/facility/history-audit'
      preLoaderRoute: typeof FacilityHistoryAuditRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/history': {
      id: '/facility/history'
      path: '/history'
      fullPath: '/facility/history'
      preLoaderRoute: typeof FacilityHistoryRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/delete-account': {
      id: '/facility/delete-account'
      path: '/delete-account'
      fullPath: '/facility/delete-account'
      preLoaderRoute: typeof FacilityDeleteAccountRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/change-password': {
      id: '/facility/change-password'
      path: '/change-password'
      fullPath: '/facility/change-password'
      preLoaderRoute: typeof FacilityChangePasswordRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/bale-processed': {
      id: '/facility/bale-processed'
      path: '/bale-processed'
      fullPath: '/facility/bale-processed'
      preLoaderRoute: typeof FacilityBaleProcessedRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/bale-outbound': {
      id: '/facility/bale-outbound'
      path: '/bale-outbound'
      fullPath: '/facility/bale-outbound'
      preLoaderRoute: typeof FacilityBaleOutboundRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/bale-inbound': {
      id: '/facility/bale-inbound'
      path: '/bale-inbound'
      fullPath: '/facility/bale-inbound'
      preLoaderRoute: typeof FacilityBaleInboundRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/bale-create': {
      id: '/facility/bale-create'
      path: '/bale-create'
      fullPath: '/facility/bale-create'
      preLoaderRoute: typeof FacilityBaleCreateRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/bag-scan': {
      id: '/facility/bag-scan'
      path: '/bag-scan'
      fullPath: '/facility/bag-scan'
      preLoaderRoute: typeof FacilityBagScanRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/facility/bag-audit': {
      id: '/facility/bag-audit'
      path: '/bag-audit'
      fullPath: '/facility/bag-audit'
      preLoaderRoute: typeof FacilityBagAuditRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/terms': {
      id: '/_app/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof AppTermsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/subscription': {
      id: '/_app/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AppSubscriptionRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/signup-details': {
      id: '/_app/signup-details'
      path: '/signup-details'
      fullPath: '/signup-details'
      preLoaderRoute: typeof AppSignupDetailsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/shop': {
      id: '/_app/shop'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof AppShopRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/scan-history': {
      id: '/_app/scan-history'
      path: '/scan-history'
      fullPath: '/scan-history'
      preLoaderRoute: typeof AppScanHistoryRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/scan': {
      id: '/_app/scan'
      path: '/scan'
      fullPath: '/scan'
      preLoaderRoute: typeof AppScanRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/rewards': {
      id: '/_app/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof AppRewardsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/report-issue': {
      id: '/_app/report-issue'
      path: '/report-issue'
      fullPath: '/report-issue'
      preLoaderRoute: typeof AppReportIssueRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/privacy': {
      id: '/_app/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof AppPrivacyRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/past-winners': {
      id: '/_app/past-winners'
      path: '/past-winners'
      fullPath: '/past-winners'
      preLoaderRoute: typeof AppPastWinnersRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/inform-existing': {
      id: '/_app/inform-existing'
      path: '/inform-existing'
      fullPath: '/inform-existing'
      preLoaderRoute: typeof AppInformExistingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/enter-code': {
      id: '/_app/enter-code'
      path: '/enter-code'
      fullPath: '/enter-code'
      preLoaderRoute: typeof AppEnterCodeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/delete-account': {
      id: '/_app/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof AppDeleteAccountRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/choose-subscription': {
      id: '/_app/choose-subscription'
      path: '/choose-subscription'
      fullPath: '/choose-subscription'
      preLoaderRoute: typeof AppChooseSubscriptionRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/checkout-product': {
      id: '/_app/checkout-product'
      path: '/checkout-product'
      fullPath: '/checkout-product'
      preLoaderRoute: typeof AppCheckoutProductRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/change-password': {
      id: '/_app/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AppChangePasswordRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/cancel-auto-renew': {
      id: '/_app/cancel-auto-renew'
      path: '/cancel-auto-renew'
      fullPath: '/cancel-auto-renew'
      preLoaderRoute: typeof AppCancelAutoRenewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/bag-scanned': {
      id: '/_app/bag-scanned'
      path: '/bag-scanned'
      fullPath: '/bag-scanned'
      preLoaderRoute: typeof AppBagScannedRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/app-updates': {
      id: '/_app/app-updates'
      path: '/app-updates'
      fullPath: '/app-updates'
      preLoaderRoute: typeof AppAppUpdatesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/about-subscriptions': {
      id: '/_app/about-subscriptions'
      path: '/about-subscriptions'
      fullPath: '/about-subscriptions'
      preLoaderRoute: typeof AppAboutSubscriptionsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/council/$councilId': {
      id: '/council/$councilId'
      path: '/$councilId'
      fullPath: '/council/$councilId'
      preLoaderRoute: typeof CouncilCouncilIdRouteRouteImport
      parentRoute: typeof CouncilRouteRoute
    }
    '/council/$councilId/': {
      id: '/council/$councilId/'
      path: '/'
      fullPath: '/council/$councilId/'
      preLoaderRoute: typeof CouncilCouncilIdIndexRouteImport
      parentRoute: typeof CouncilCouncilIdRouteRoute
    }
    '/facility/edit-scan/$scanId': {
      id: '/facility/edit-scan/$scanId'
      path: '/edit-scan/$scanId'
      fullPath: '/facility/edit-scan/$scanId'
      preLoaderRoute: typeof FacilityEditScanScanIdRouteImport
      parentRoute: typeof FacilityRouteRoute
    }
    '/council/$councilId/dashboard': {
      id: '/council/$councilId/dashboard'
      path: '/dashboard'
      fullPath: '/council/$councilId/dashboard'
      preLoaderRoute: typeof CouncilCouncilIdDashboardRouteImport
      parentRoute: typeof CouncilCouncilIdRouteRoute
    }
    '/_app/subscription-detail/$productId': {
      id: '/_app/subscription-detail/$productId'
      path: '/subscription-detail/$productId'
      fullPath: '/subscription-detail/$productId'
      preLoaderRoute: typeof AppSubscriptionDetailProductIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/checkout-subscription/$productPriceId': {
      id: '/_app/checkout-subscription/$productPriceId'
      path: '/checkout-subscription/$productPriceId'
      fullPath: '/checkout-subscription/$productPriceId'
      preLoaderRoute: typeof AppCheckoutSubscriptionProductPriceIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/checkout-subscription-result/$sessionId': {
      id: '/_app/checkout-subscription-result/$sessionId'
      path: '/checkout-subscription-result/$sessionId'
      fullPath: '/checkout-subscription-result/$sessionId'
      preLoaderRoute: typeof AppCheckoutSubscriptionResultSessionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/checkout-product-result/$sessionId': {
      id: '/_app/checkout-product-result/$sessionId'
      path: '/checkout-product-result/$sessionId'
      fullPath: '/checkout-product-result/$sessionId'
      preLoaderRoute: typeof AppCheckoutProductResultSessionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppAboutSubscriptionsRoute: typeof AppAboutSubscriptionsRoute
  AppAccountRoute: typeof AppAccountRoute
  AppAlertsRoute: typeof AppAlertsRoute
  AppAppUpdatesRoute: typeof AppAppUpdatesRoute
  AppBagScannedRoute: typeof AppBagScannedRoute
  AppBillingRoute: typeof AppBillingRoute
  AppCancelAutoRenewRoute: typeof AppCancelAutoRenewRoute
  AppChangePasswordRoute: typeof AppChangePasswordRoute
  AppCheckoutProductRoute: typeof AppCheckoutProductRoute
  AppChooseSubscriptionRoute: typeof AppChooseSubscriptionRoute
  AppDeleteAccountRoute: typeof AppDeleteAccountRoute
  AppEnterCodeRoute: typeof AppEnterCodeRoute
  AppHelpRoute: typeof AppHelpRoute
  AppHomeRoute: typeof AppHomeRoute
  AppInformExistingRoute: typeof AppInformExistingRoute
  AppPastWinnersRoute: typeof AppPastWinnersRoute
  AppPrivacyRoute: typeof AppPrivacyRoute
  AppReportIssueRoute: typeof AppReportIssueRoute
  AppRewardsRoute: typeof AppRewardsRoute
  AppScanRoute: typeof AppScanRoute
  AppScanHistoryRoute: typeof AppScanHistoryRoute
  AppShopRoute: typeof AppShopRoute
  AppSignupDetailsRoute: typeof AppSignupDetailsRoute
  AppSubscriptionRoute: typeof AppSubscriptionRoute
  AppTermsRoute: typeof AppTermsRoute
  AppAboutLazyRoute: typeof AppAboutLazyRoute
  AppIndexLazyRoute: typeof AppIndexLazyRoute
  AppCheckoutProductResultSessionIdRoute: typeof AppCheckoutProductResultSessionIdRoute
  AppCheckoutSubscriptionResultSessionIdRoute: typeof AppCheckoutSubscriptionResultSessionIdRoute
  AppCheckoutSubscriptionProductPriceIdRoute: typeof AppCheckoutSubscriptionProductPriceIdRoute
  AppSubscriptionDetailProductIdRoute: typeof AppSubscriptionDetailProductIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAboutSubscriptionsRoute: AppAboutSubscriptionsRoute,
  AppAccountRoute: AppAccountRoute,
  AppAlertsRoute: AppAlertsRoute,
  AppAppUpdatesRoute: AppAppUpdatesRoute,
  AppBagScannedRoute: AppBagScannedRoute,
  AppBillingRoute: AppBillingRoute,
  AppCancelAutoRenewRoute: AppCancelAutoRenewRoute,
  AppChangePasswordRoute: AppChangePasswordRoute,
  AppCheckoutProductRoute: AppCheckoutProductRoute,
  AppChooseSubscriptionRoute: AppChooseSubscriptionRoute,
  AppDeleteAccountRoute: AppDeleteAccountRoute,
  AppEnterCodeRoute: AppEnterCodeRoute,
  AppHelpRoute: AppHelpRoute,
  AppHomeRoute: AppHomeRoute,
  AppInformExistingRoute: AppInformExistingRoute,
  AppPastWinnersRoute: AppPastWinnersRoute,
  AppPrivacyRoute: AppPrivacyRoute,
  AppReportIssueRoute: AppReportIssueRoute,
  AppRewardsRoute: AppRewardsRoute,
  AppScanRoute: AppScanRoute,
  AppScanHistoryRoute: AppScanHistoryRoute,
  AppShopRoute: AppShopRoute,
  AppSignupDetailsRoute: AppSignupDetailsRoute,
  AppSubscriptionRoute: AppSubscriptionRoute,
  AppTermsRoute: AppTermsRoute,
  AppAboutLazyRoute: AppAboutLazyRoute,
  AppIndexLazyRoute: AppIndexLazyRoute,
  AppCheckoutProductResultSessionIdRoute:
    AppCheckoutProductResultSessionIdRoute,
  AppCheckoutSubscriptionResultSessionIdRoute:
    AppCheckoutSubscriptionResultSessionIdRoute,
  AppCheckoutSubscriptionProductPriceIdRoute:
    AppCheckoutSubscriptionProductPriceIdRoute,
  AppSubscriptionDetailProductIdRoute: AppSubscriptionDetailProductIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface CouncilCouncilIdRouteRouteChildren {
  CouncilCouncilIdDashboardRoute: typeof CouncilCouncilIdDashboardRoute
  CouncilCouncilIdIndexRoute: typeof CouncilCouncilIdIndexRoute
}

const CouncilCouncilIdRouteRouteChildren: CouncilCouncilIdRouteRouteChildren = {
  CouncilCouncilIdDashboardRoute: CouncilCouncilIdDashboardRoute,
  CouncilCouncilIdIndexRoute: CouncilCouncilIdIndexRoute,
}

const CouncilCouncilIdRouteRouteWithChildren =
  CouncilCouncilIdRouteRoute._addFileChildren(
    CouncilCouncilIdRouteRouteChildren,
  )

interface CouncilRouteRouteChildren {
  CouncilCouncilIdRouteRoute: typeof CouncilCouncilIdRouteRouteWithChildren
  CouncilIndexRoute: typeof CouncilIndexRoute
}

const CouncilRouteRouteChildren: CouncilRouteRouteChildren = {
  CouncilCouncilIdRouteRoute: CouncilCouncilIdRouteRouteWithChildren,
  CouncilIndexRoute: CouncilIndexRoute,
}

const CouncilRouteRouteWithChildren = CouncilRouteRoute._addFileChildren(
  CouncilRouteRouteChildren,
)

interface FacilityRouteRouteChildren {
  FacilityBagAuditRoute: typeof FacilityBagAuditRoute
  FacilityBagScanRoute: typeof FacilityBagScanRoute
  FacilityBaleCreateRoute: typeof FacilityBaleCreateRoute
  FacilityBaleInboundRoute: typeof FacilityBaleInboundRoute
  FacilityBaleOutboundRoute: typeof FacilityBaleOutboundRoute
  FacilityBaleProcessedRoute: typeof FacilityBaleProcessedRoute
  FacilityChangePasswordRoute: typeof FacilityChangePasswordRoute
  FacilityDeleteAccountRoute: typeof FacilityDeleteAccountRoute
  FacilityHistoryRoute: typeof FacilityHistoryRoute
  FacilityHistoryAuditRoute: typeof FacilityHistoryAuditRoute
  FacilityHistoryBagRoute: typeof FacilityHistoryBagRoute
  FacilityHomeRoute: typeof FacilityHomeRoute
  FacilitySettingsRoute: typeof FacilitySettingsRoute
  FacilityEditScanScanIdRoute: typeof FacilityEditScanScanIdRoute
}

const FacilityRouteRouteChildren: FacilityRouteRouteChildren = {
  FacilityBagAuditRoute: FacilityBagAuditRoute,
  FacilityBagScanRoute: FacilityBagScanRoute,
  FacilityBaleCreateRoute: FacilityBaleCreateRoute,
  FacilityBaleInboundRoute: FacilityBaleInboundRoute,
  FacilityBaleOutboundRoute: FacilityBaleOutboundRoute,
  FacilityBaleProcessedRoute: FacilityBaleProcessedRoute,
  FacilityChangePasswordRoute: FacilityChangePasswordRoute,
  FacilityDeleteAccountRoute: FacilityDeleteAccountRoute,
  FacilityHistoryRoute: FacilityHistoryRoute,
  FacilityHistoryAuditRoute: FacilityHistoryAuditRoute,
  FacilityHistoryBagRoute: FacilityHistoryBagRoute,
  FacilityHomeRoute: FacilityHomeRoute,
  FacilitySettingsRoute: FacilitySettingsRoute,
  FacilityEditScanScanIdRoute: FacilityEditScanScanIdRoute,
}

const FacilityRouteRouteWithChildren = FacilityRouteRoute._addFileChildren(
  FacilityRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  CouncilRouteRoute: CouncilRouteRouteWithChildren,
  FacilityRouteRoute: FacilityRouteRouteWithChildren,
  PasswordLinkSentRoute: PasswordLinkSentRoute,
  RequestPasswordResetRoute: RequestPasswordResetRoute,
  SelectContextRoute: SelectContextRoute,
  SignupRoute: SignupRoute,
  UnauthorisedRoute: UnauthorisedRoute,
  WelcomeRoute: WelcomeRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
